import { FormEvent, useState } from 'react';
import { db } from '@/lib/db';
import type { PostEnriched } from '@/lib/db/types';
import { Sheet } from '@/components/shared/Sheet';

interface Props {
  post: PostEnriched;
  onClose: () => void;
  onSaved: (body: string) => void;
}

export function EditPostSheet({ post, onClose, onSaved }: Props) {
  const [body, setBody] = useState(post.body || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await db.posts.update(post.id, { body: body.trim() || undefined });
      onSaved(body.trim());
      onClose();
    } catch (err) {
      setError((err as Error).message || 'Could not save changes');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Sheet title="Edit Post" onClose={onClose}>
      <form onSubmit={submit} className="space-y-4 p-4 pb-10">
        <textarea
          rows={5}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="What's on your mind?"
          className="w-full resize-none rounded-xl border border-line bg-paper px-3 py-2 text-sm"
          autoFocus
        />
        {error && <div className="rounded-xl bg-red-50 p-3 text-sm text-red-700">{error}</div>}
        <button type="submit" disabled={saving} className="w-full rounded-full bg-gold py-3 text-sm font-bold text-navy disabled:opacity-50">
          {saving ? 'Saving…' : 'Save'}
        </button>
      </form>
    </Sheet>
  );
}
